import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FinanceCRMWebhookDialog({ onClose }) {
  const [url, setUrl] = useState('');
  const [token, setToken] = useState('');
  const [hasToken, setHasToken] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/finance/crm-webhook-config`).then(({ data }) => {
      setUrl(data.url || '');
      setHasToken(!!data.has_token);
    }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      // Only send the token if user typed something (avoids wiping existing)
      const body = { url };
      if (token) body.token = token;
      await axios.put(`${API}/finance/crm-webhook-config`, body);
      toast.success("Webhook CRM enregistré");
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="finance-webhook-dialog">
        <DialogHeader><DialogTitle>Webhook CRM custom</DialogTitle></DialogHeader>
        <div className="space-y-3 py-2">
          <p className="text-sm text-neutral-600">
            Lorsque vous cliquez « → Webhook » sur une facture, le module envoie un POST JSON à cette URL.
            Idéal pour relier Pennylane, Quickbooks, Make/Zapier, ou tout autre service de facturation.
          </p>
          <div>
            <Label className="text-xs text-neutral-500">URL du webhook</Label>
            <Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://hooks.zapier.com/..." data-testid="webhook-url" />
          </div>
          <div>
            <Label className="text-xs text-neutral-500">
              Bearer token (optionnel — envoyé en header Authorization)
            </Label>
            <Input type="password" value={token} onChange={(e) => setToken(e.target.value)}
              placeholder={hasToken ? '••••••••••• (token déjà enregistré)' : 'Aucun token'}
              data-testid="webhook-token" />
            {hasToken && <p className="text-[11px] text-neutral-500 mt-1">Laisser vide pour conserver l'actuel.</p>}
          </div>
          <div className="bg-neutral-50 border border-neutral-200 rounded p-3">
            <p className="text-xs font-semibold text-neutral-700 mb-1">Payload envoyé :</p>
            <pre className="text-[11px] text-neutral-600 overflow-x-auto">
{`{
  "event": "invoice.created",
  "source": "aegis_finance",
  "invoice": {
    "id": "...",
    "client_id": "...",
    "client_name": "...",
    "month": "YYYY-MM",
    "type": "monthly_fee | backlinks | website | other",
    "label": "...",
    "amount": 850.0,
    "currency": "EUR"
  }
}`}
            </pre>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annuler</Button>
          <Button onClick={save} disabled={saving} data-testid="webhook-save">{saving ? '…' : 'Enregistrer'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
